import React, { Component } from 'react';
import { Field } from 'redux-form';
import { intlShape, injectIntl } from 'react-intl';
import TextField from '../../TextField/TextField';
import { isEmpty } from '../../FormElement/FormElementUtils';
import PropTypes from 'prop-types';

export class Street1 extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        localePrefix: PropTypes.string.isRequired
    };

    render() {
        const { intl, localePrefix } = this.props;

        return (
            <div>
                <Field
                    id="street1"
                    name="street1"
                    autoComplete="disabled"
                    required={true}
                    component={TextField}
                    label={intl.formatMessage({id: `${localePrefix}.addressLine1`})}
                    validate={[
                        isEmpty(intl.formatMessage({id: `${localePrefix}.ADDRESSLINE1_IS_NULL`}))
                    ]}
                />
            </div>
        );
    }
}

export default injectIntl(Street1);
